import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";

const { FiUploadCloud, FiInfo } = FiIcons;

const LoadingSpinner = ({ quoteData, uploadProgress }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setElapsedTime((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <motion.div
      className="w-full max-w-sm text-center flex flex-col items-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      {/* --- START: Modern Spinner --- */}
      <div className="relative w-28 h-28">
        {/* Spinner ที่หมุน (ใช้ SVG และ animate-spin ของ Tailwind) */}
        <svg
          className="w-full h-full animate-spin"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="stroke-green-500"
            cx="50"
            cy="50"
            r="45"
            fill="transparent"
            strokeWidth="8"
            // stroke-dasharray ทำให้เกิดช่องว่างในวงกลม
            strokeDasharray="210 282" // 282 คือเส้นรอบวง, 210 คือความยาวเส้น
            strokeLinecap="round"
          />
        </svg>

        {/* ไอคอนตรงกลาง */}
        <div className="absolute inset-0 flex items-center justify-center">
          <SafeIcon icon={FiUploadCloud} className="w-12 h-12 text-slate-400" />
        </div>
      </div>
      {/* --- END: Modern Spinner --- */}

      {/* Status Text */}
      <div className="mt-6 w-full">
        <h2 className="text-xl font-semibold text-slate-700">
          {uploadProgress < 100
            ? "กำลังอัปโหลดไฟล์..."
            : "ไฟล์ของคุณกำลังถูกประมวลผล"}
        </h2>

        {uploadProgress < 100 ? (
          <div className="mt-4">
            <div className="w-full bg-slate-200 rounded-full h-2.5">
              <motion.div
                className="bg-green-600 h-2.5 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${uploadProgress}%` }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              />
            </div>
            <p className="text-center text-lg font-semibold text-slate-600 mt-2">
              {uploadProgress}%
            </p>
          </div>
        ) : (
          <p className="mt-2 font-mono text-slate-500 text-2xl tracking-wider">
            {formatTime(elapsedTime)}
          </p>
        )}
      </div>

      {/* Information Box */}
      <div className="mt-8 text-sm text-slate-500 bg-slate-100 p-4 rounded-lg border border-slate-200 w-full">
        <div className="flex items-start gap-3">
          <SafeIcon
            icon={FiInfo}
            className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0"
          />
          <div>
            <p className="font-semibold text-slate-600">
              กรุณาเปิดหน้านี้ทิ้งไว้
            </p>
            <p className="mt-1">
              การประมวลผลอาจใช้เวลาสักครู่ (ไฟล์ 1 ชั่วโมง อาจใช้เวลาประมาณ 5-7
              นาที)
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default LoadingSpinner;
